module.exports = __webpack_public_path__ + "img/expostyle_0904_sky_blue.4222e7a2.jpg";